/** Uruguay departments — Title Case, no accents (aligned with client.province AR/UY seed). */
export const uruguayDepartments = [
  { id: '025', label: 'Artigas' },
  { id: '026', label: 'Canelones' },
  { id: '027', label: 'Cerro Largo' },
  { id: '028', label: 'Colonia' },
  { id: '029', label: 'Durazno' },
  { id: '030', label: 'Flores' },
  { id: '031', label: 'Florida' },
  { id: '032', label: 'Lavalleja' },
  { id: '033', label: 'Maldonado' },
  { id: '034', label: 'Montevideo' },
  { id: '035', label: 'Paysandu' },
  { id: '036', label: 'Rio Negro' },
  { id: '037', label: 'Rivera' },
  { id: '038', label: 'Rocha' },
  { id: '039', label: 'Salto' },
  { id: '040', label: 'San Jose' },
  { id: '041', label: 'Soriano' },
  { id: '042', label: 'Tacuarembo' },
  { id: '043', label: 'Treinta Y Tres' },
  { id: '044', label: 'Limite Contestado' },
];
